import { prop } from 'ramda';
import { createSelector } from 'reselect';
import { shallow } from 'zustand/shallow';
import { NormalizedJackpotsType } from '../../../types';
import { IInHouseJackpotsState, useInHouseJackpotsSelector } from '../../store';

const selectJackpots = (state: IInHouseJackpotsState): NormalizedJackpotsType =>
  prop('jackpots')(state);

export const selectInHouseJackpotWinnersGamesLaunchIds = () =>
  createSelector(
    selectJackpots,
    (jackpots: NormalizedJackpotsType): string[] => {
      const ids = [];
      for (const jackpot of Object.values(jackpots)) {
        for (const winner of [jackpot.lastWinner, jackpot.maxWinner]) {
          if (winner?.gameId) {
            ids.push(winner.gameId);
          }
        }
      }
      return ids;
    }
  );

export const useGetInHouseJackpotWinnersGamesLaunchIds = (): string[] =>
  useInHouseJackpotsSelector(
    selectInHouseJackpotWinnersGamesLaunchIds,
    [],
    shallow
  );
